export default {"src":"/_next/static/media/smiley.e4817924.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};